import React, { Fragment, useContext, useState } from "react";
import { LogIn, MoreHorizontal } from "react-feather";
import { Button, Media } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { LI, UL } from "../../AbstractElements";
import MaxMiniSize from "./MaxMiniSize";
import MoonLight from "./MoonLight";
import AuthContext from "../../Context/AuthContext";
import Notifications from "./Notification";
import { getUser } from "../../Utils/externalFunctions";
import { admins, timeToast } from "../../Constant";
import useAxios from "../../Utils/useAxios";
import { berhasilMembuatItemMsg, berhasilMengubahItemMsg } from "../../Constant/Message";
import { toast } from "react-toastify";

const HeaderContain = () => {
  const axiosInstance = useAxios();
  const navigate = useNavigate();
  const isAdmin = admins.includes(getUser());
  const { logoutUser } = useContext(AuthContext);
  const userRole = localStorage.getItem("role");

  const [open, setOpen] = useState(false);
  const onAdd = () => {
    setOpen(!open);
  };

  const changeUser = async (e) => {
    console.log("change user");
    e.preventDefault();

    const formLoginAs = {
      username: userRole,
    };

    try {
      const response = await axiosInstance.post("loginas/", formLoginAs);
      if (response.status === 200) {
        localStorage.removeItem("role");
        localStorage.setItem("username", response.data.username);
        localStorage.setItem("authTokens", JSON.stringify(response.data.token));
        toast.success(berhasilMengubahItemMsg("Akun"), {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: timeToast,
        });
        window.location.href = `${process.env.PUBLIC_URL}/dashboard`;
      }
    } catch (error) {
      toast.error(error.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
    }
  };

  const generateOTP = async () => {
    const response = await axiosInstance.get("generate-otp/")
    if (response.status === 201) {
      toast.success(berhasilMembuatItemMsg("Kode OTP"), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
    }
  }

  return (
    <Fragment>
      <div className="nav-right col pull-right right-menu">
        <UL
          attrUL={{
            className: `simple-list d-flex flex-row nav-menus ${
              open ? "open" : ""
            }`,
          }}
        >
          <LI attrLI={{ className: "onhover-dropdown" }}>
            <a className="txt-dark" href="#javascript"></a>
          </LI>
          <Notifications />
          <MoonLight />
          <MaxMiniSize />
          <LI attrLI={{ className: "onhover-dropdown" }}>
            <Media body>
              <span>{localStorage.getItem("username")}</span>
            </Media>
            <UL
              attrUL={{
                className: "simple-list profile-dropdown onhover-show-div",
              }}
            >
              {/* {isAdmin && (
                <LI>
                  <Link
                    to={`${process.env.PUBLIC_URL}/OTP`}
                    className="btn btn-light w-100"
                    onClick={() => generateOTP()}
                  >
                    Login As
                  </Link>
                </LI>
              )} */}
              {/* {userRole && (
                <LI>
                  <Button
                    className="btn btn-light w-100"
                    onClick={(e) => changeUser(e)}
                  >
                    {userRole}
                  </Button>
                </LI>
              )} */}
              <LI attrLI={{ onClick: logoutUser }}>
                <Link
                  to={`${process.env.PUBLIC_URL}/login`}
                  className="btn btn-light w-100"
                >
                  <LogIn /> Logout
                </Link>
              </LI>
            </UL>
          </LI>
        </UL>
      </div>
      <div
        className="d-lg-none col mobile-toggle pull-right"
        onClick={() => onAdd()}
      >
        <i>
          <MoreHorizontal />
        </i>
      </div>
    </Fragment>
  );
};
export default HeaderContain;
